import api from './api';

/**
 * Admin Service
 * API calls for admin panel functionality
 */
export const adminService = {
  // Dashboard
  getDashboardStats: async () => {
    return await api.get('/admin/dashboard');
  },

  // Merchants
  getAllMerchants: async (params = {}) => {
    return await api.get('/admin/merchants', { params });
  },

  getMerchantById: async (merchantId) => {
    return await api.get(`/admin/merchants/${merchantId}`);
  },

  createMerchant: async (data) => {
    return await api.post('/admin/merchants', data);
  },

  updateMerchant: async (merchantId, data) => {
    return await api.put(`/admin/merchants/${merchantId}`, data);
  },

  deleteMerchant: async (merchantId) => {
    return await api.delete(`/admin/merchants/${merchantId}`);
  },

  verifyMerchant: async (merchantId) => {
    return await api.post(`/admin/merchants/${merchantId}/verify`);
  },

  // Subscriptions
  getAllSubscriptions: async (params = {}) => {
    return await api.get('/admin/subscriptions', { params });
  },

  getSubscriptionById: async (subscriptionId) => {
    return await api.get(`/admin/subscriptions/${subscriptionId}`);
  },

  updateSubscription: async (subscriptionId, data) => {
    return await api.put(`/admin/subscriptions/${subscriptionId}`, data);
  },

  renewSubscription: async (subscriptionId) => {
    return await api.post(`/admin/subscriptions/${subscriptionId}/renew`);
  },

  // Analytics
  getAnalytics: async (params = {}) => {
    return await api.get('/admin/analytics', { params });
  },

  getRevenueAnalytics: async (params = {}) => {
    return await api.get('/admin/analytics/revenue', { params });
  },

  getUserAnalytics: async (params = {}) => {
    return await api.get('/admin/analytics/users', { params });
  },

  // System Settings
  getSystemSettings: async () => {
    return await api.get('/admin/settings');
  },

  updateSystemSettings: async (data) => {
    return await api.put('/admin/settings', data);
  },

  // Export - Use direct URL construction for file downloads
  exportMerchantsExcel: async (filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    const url = `/export/merchants/excel?${params}`;
    return { url };
  },

  exportMerchantsPDF: async (filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    const url = `/export/merchants/pdf?${params}`;
    return { url };
  },

  exportSubscriptionsExcel: async (filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    const url = `/export/subscriptions/excel?${params}`;
    return { url };
  },

  exportSubscriptionsPDF: async (filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    const url = `/export/subscriptions/pdf?${params}`;
    return { url };
  }
};
